<template>
  <el-drawer custom-class="c-app-side-drawer__global" v-model="isOpen" v-bind="innerDrawerAttrs">
    <slot />
  </el-drawer>
</template>

<script setup lang="ts">
import { _, computed, onMounted, reactive, ref, watch, useHostAppInstance } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    name?: string // 活动名称
    size?: number | string // draw大小
    component?: any // 内部组件
    withHeader?: boolean
    innerAttrs?: any
  }>(),
  {
    withHeader: false,
    size: 420
  }
)

const app = useHostAppInstance()

const isOpen = ref<boolean>(false)

const innerDrawerAttrs = computed(() => {
  return {
    style: { width: '920px' },
    size: props.size,
    zIndex: 2000,
    withHeader: false
    // ...props.innerAttrs?.drawer
  }
})

function show() {
  isOpen.value = true
}

defineExpose({
  show
})
</script>

<style lang="scss">
.c-app-side-drawer {
  &__global {
    &.el-drawer {
      top: var(--app-header-height);
      height: calc(100vh - var(--app-header-height));
    }
  }
}
</style>
